import * as storageKey from './storageKey';
import isTabReuseEnabled from './isTabReuseEnabled';
import * as localStorageWrapper from 'owa-local-storage/lib/localStorageAdapter';

export default function initializeTabReuse(tabName: string) {
    if (!isTabReuseEnabled()) {
        return;
    }

    // extract shared storage key if one exists; set if not
    const key = storageKey.extract();
    if (key) {
        // child window
        storageKey.set(key);
    } else {
        // parent window
        storageKey.generate();
    }

    // name tab and record in localStorage
    const originalWindowName = window.name;
    const windowName = storageKey.getTabKey(tabName);
    window.name = windowName;
    localStorageWrapper.setItem(window, windowName, '1');

    // cleanup once OWA is unloaded
    (<Window>window).addEventListener('beforeunload', cleanup);
    (<Window>window).addEventListener('unload', cleanup);

    function cleanup() {
        localStorageWrapper.removeItem(window, windowName);
        window.name = originalWindowName;
    }
}
